// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FICQ6,.Lw2Jg,.xqLAl{color:#22b6e7;text-decoration:none;-webkit-transition:.2s;transition:.2s}@media(hover:hover){.FICQ6:hover,.Lw2Jg:hover,.xqLAl:hover{text-decoration:underline}}.FICQ6{color:inherit}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inheritColorLink": `FICQ6`,
	"link": `Lw2Jg`,
	"root": `xqLAl`
};
module.exports = ___CSS_LOADER_EXPORT___;
